import React from 'react'
import { useTheme } from 'react-jss'

import { formatCurrency } from '@portal/kit/pkg/helpers'

import selectedOfferStyle from './selected-offer-style'
import { useTranslation } from 'react-i18next'

export default function SelectedOffer ({ offer, catalog, isDetailed = true}) {
  const theme = useTheme()
  const { i18n } = useTranslation()
  const classes = selectedOfferStyle(theme)

  return (
    <div className={classes.selectedOffer}>
      <div className={classes.selectedOfferWrap}>
        <div className={classes.offerMain}>
          {isDetailed && catalog && <p className={classes.catalogName}>{catalog.locales[i18n.language].name}</p>}
          <p className={classes.offerName}>{offer.locales[i18n.language].name}</p>
          {
            isDetailed
            && offer.locales[i18n.language].description_1 !== 'unused'
            && <p className={classes.offerDescription} dangerouslySetInnerHTML={{ __html: offer.locales[i18n.language].description_1 }} />
          }
        </div>
        {!isDetailed &&
          <p className={classes.offerPrice}>
            {i18n.t('portal.offers.ttc_price', { formattedPrice: formatCurrency(offer.price, offer.currency, i18n.language) })}
          </p>
        }
      </div>
      {isDetailed &&
        <p className={classes.offerDetailedPrice}>
          <span>{i18n.t('portal.offers.total')} </span>
          <strong>{i18n.t('portal.offers.ttc_price', { formattedPrice: formatCurrency(offer.price, offer.currency, i18n.language) })}</strong>
        </p>
      }
    </div>
  )
}
